import { Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { NavLink } from 'react-router';
import { getUserNames } from '../../../common/string/get-user-names';
import { AwardSummary } from '../../../models';
import { RoutePaths } from '../../../route-paths';
import './AwardGroupList.scss';

interface AwardGroupListProps {
  awardSummaries: AwardSummary[]
}

const AwardGroupListImpl: React.FC<AwardGroupListProps> = (props) => {
  const {
    awardSummaries,
  } = props;

  return (
    <Table className='award-group-list'>
      <TableHeader>
        <TableRow>
          <TableHeaderCell className='col-award'>Award</TableHeaderCell>
          <TableHeaderCell>Award Lead</TableHeaderCell>
          <TableHeaderCell>Judges</TableHeaderCell>
          <TableHeaderCell>Total Nominations</TableHeaderCell>
          <TableHeaderCell>Passed</TableHeaderCell>
          <TableHeaderCell>Disqualified</TableHeaderCell>
          <TableHeaderCell>Judged</TableHeaderCell>
          <TableHeaderCell>Winner</TableHeaderCell>
          <TableHeaderCell className='col-finalist'>Finalists</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {
          awardSummaries.map((awardSummary) => {
            return (
              <TableRow
                key={awardSummary.awardId}
              >
                <TableCell className='col-award'>
                  <NavLink
                    to={RoutePaths.Awards + '/' + awardSummary.awardId}
                    end
                  >
                    {awardSummary.title}
                  </NavLink>
                </TableCell>
                <TableCell>{getUserNames(awardSummary.leads)}</TableCell>
                <TableCell>{awardSummary.numberOfJudges}</TableCell>
                <TableCell>{awardSummary.numberOfNominations}</TableCell>
                <TableCell>{awardSummary.numberOfPassedNominations}</TableCell>
                <TableCell>{awardSummary.numberOfDisqualifiedNominations}</TableCell>
                <TableCell>{awardSummary.numberOfJudgedNominations}</TableCell>
                <TableCell>{awardSummary.winnerHasBeenAssigned ? 'Yes' : ''}</TableCell>
                <TableCell className='col-finalist'>{awardSummary.numberOfFinalists > 0 ? awardSummary.numberOfFinalists : ''}</TableCell>
              </TableRow>
            );
          })
        }
      </TableBody>
    </Table>
  );
}

export const AwardGroupList = observer(AwardGroupListImpl);
